import { CloseButton, UserMessage } from '@lili/lili-frontend-common';
import React, { useEffect } from 'react';
import { LimitsModalRightComponent } from './LimitsModalRightComponent';
import { LimitsModalLeftComponent } from './LimitsModalLeftComponent';
import { TierResponse } from '../AccountLimitsType';
import { reportViewLimitsIncreaseBottomSheet } from '../limits.analytics';

interface LimitsModalProps {
  handleCloseModal: () => void;
  teirData: TierResponse;
  handleRequestUpgrade: () => void;
  loadingRequestUpgrade: boolean;
}
export const LimitsModal = ({
  handleCloseModal,
  teirData,
  handleRequestUpgrade,
  loadingRequestUpgrade,
}: LimitsModalProps) => {
  useEffect(() => {
    reportViewLimitsIncreaseBottomSheet();
  }, []);
  return (
    <UserMessage
      onClick={handleCloseModal}
      id='limits-modal'
      mainWrapperClassName='w-full h-full flex content-center items-center'
    >
      <div className='w-[1069px] h-[480px]  flex justify-center items-center '>
        <div className=' absolute top-[12px] right-[10px]'>
          <CloseButton className='w-[20px] h-[20px]' id='close' onClick={handleCloseModal} />
        </div>
        <LimitsModalLeftComponent
          handleCloseModal={handleCloseModal}
          handleRequestUpgrade={handleRequestUpgrade}
          loadingRequestUpgrade={loadingRequestUpgrade}
        />
        <LimitsModalRightComponent teirData={teirData} />
      </div>
    </UserMessage>
  );
};
